import { IReportRowAM, IReportValueRowAM } from "../features/reporting/report-api";
import { ReportFinancialPrecision } from "../features/reporting/models/report-template";

export function convertFinancialPrecisionToDecimals(row: IReportRowAM, precision: ReportFinancialPrecision): number {
	// Preserve formatting for non-financial rows
	const unit = (row as IReportValueRowAM)?.unit;
	if (unit && unit !== '€' && unit !== "t€") {
		return 2;
	}
	
	const decimals 
		= precision == ReportFinancialPrecision.Decimal || precision == ReportFinancialPrecision.None
		 	? 2
		 	: 0;

	return decimals;
}
